module.exports = __webpack_public_path__ + "static/media/image-5.3b3ecee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/StateofSocial/image-5.jpg
// module id = 87
// module chunks = 0